import React, { Component } from 'react';
import {
    Table, Icon, Divider, Button, Popconfirm,
} from 'antd';
import MachineContactsAddContainer from '../containers/MachineContactsAddContainer';
import constants from '../../constants';

class MachineManagersView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            managerId: null,
        };
        this.onCancel = this.onCancel.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    onCancel() {
        this.closeForm();
    }

    onDelete(id) {
        this.props.deleteLog(id);
    }


    confirm(e) {
        console.log(e);
        this.onDelete(e);
    }

    cancel(e) {
        console.log(e);
        // message.error('Click en ');
    }

    closeForm() {
        this.setState({
            openForm: false,
        });
    }

    render() {
        let columns = [
            {
                title: 'Empresa',
                dataIndex: 'company',
                key: 'company',
            },
            {
                title: 'Nombre',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Apellidos',
                dataIndex: 'lastname',
                key: 'lastname',
            },
            {
                title: 'Teléfono',
                dataIndex: 'phone1',
                key: 'phone1',
            },
            {
                title: 'Máquinas',
                dataIndex: 'machines',
                key: 'machines',
            },
        ];

        if (this.props.extraUser.type === constants.ADMIN_ROLE
            || this.props.extraUser.type === constants.SADMIN_ROLE
            || this.props.extraUser.type === constants.SUPV_ROLE) {
            columns = columns.concat(
                {
                    title: 'Opciones',
                    key: 'action',
                    render: (text, row) => (
                        <span>
                            <Button
                                onClick={() => {
                                    this.setState({ openForm: true, managerId: row.key });
                                }}
                            >
                                <Icon type="edit" />
                            </Button>
                            <Divider type="vertical" />
                            <Popconfirm title="Estas seguro que deseas eliminar esta bitacora?" onConfirm={this.confirm.bind(this, row.key)} onCancel={this.cancel} okText="Si" cancelText="No" >
                                <Button>
                                    <Icon type="delete" />
                                </Button>
                            </Popconfirm>
                        </span>
                    ),
                },
            );
        }
        const button = (
            <Button type="primary lg col-md-4 center-block" onClick={() => { this.setState({ openForm: true, managerId: null }); }}>
                Agregar Nuevo Contacto
            </Button>
        );
        return (
            <div>
                <Table columns={columns} dataSource={this.props.managers} />

                {this.props.extraUser.type === constants.ADMIN_ROLE && button}
                {this.props.extraUser.type === constants.SADMIN_ROLE && button}
                {this.props.extraUser.type === constants.TEC_ROLE && button}
                {this.props.extraUser.type === constants.SUPV_ROLE && button}

                <MachineContactsAddContainer
                    openForm={this.state.openForm}
                    closeForm={this.closeForm}
                    onCancel={this.onCancel}
                    managerId={this.state.managerId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                    machineId={this.props.machineId}
                />
            </div>
        );
    }
}
export default MachineManagersView;



// WEBPACK FOOTER //
// ./src/components/views/MachineManagersView.js